import { FC, useState } from "react";
import Image from "@Components/Image";
import Icon from "@Components/ui/icon";
import { SectionBasic } from "@Components/ui/section";
import Link from "@wff/components/Link";
import classes from "./KnowYourCuts.module.scss";

const KYC_ICONS = ["cow-black", "lamb", "pork"];

type CMSImageType = {
  url: string;
  width: number;
  height: number;
  title?: string;
};

interface IconsContentProps {
  onIconChange: (x: number) => void;
  selectedIcon: number;
}

interface ImageContentProps {
  urls: string[];
  images: CMSImageType[];
  selectedIcon: number;
}

export interface KnowYourCutsProps {
  sections: {
    items: {
      title: string;
      description: string;
      image: CMSImageType;
      collectionUrl: string;
    }[];
  };
}

const IconsContent: FC<IconsContentProps> = (props) => {
  const { selectedIcon, onIconChange } = props;

  return (
    <div className={classes["kyc-icons"]}>
      {KYC_ICONS.map((icon, index) => (
        <div
          key={icon}
          className={`${classes["kyc-icon"]} ${
            selectedIcon === index && classes["kyc-icon--selected"]
          }`}
          onClick={() => onIconChange(index)}
        >
          <Icon iconName={icon} />
        </div>
      ))}
    </div>
  );
};

const ImageContent: FC<ImageContentProps> = ({
  urls,
  images,
  selectedIcon,
}) => (
  <Link href={`${urls[selectedIcon]}`}>
    <a>
      <Image
        className={classes["kyc-cuts"]}
        src={`${images[selectedIcon].url}?fm=webp&w=1920&h=1080`}
        alt={images[selectedIcon].title || ""}
        width={600}
        height={350}
        objectFit="cover"
      />
    </a>
  </Link>
);

const KnowYourCuts = ({ sections }: KnowYourCutsProps) => {
  const [selectedIcon, setSelectedIcon] = useState(0);

  if (!sections?.items?.length) return null;
  const images = sections?.items.map((item) => item.image);
  const urls = sections?.items.map((item) => item.collectionUrl);
  const onIconChange = (icon: number) => {
    setSelectedIcon(icon);
  };

  return (
    <SectionBasic
      className={classes.section}
      sectionButtonClassName={classes["section__button"]}
      heading={sections.items[selectedIcon]?.title}
      paragraph={sections.items[selectedIcon]?.description}
      button={
        <IconsContent selectedIcon={selectedIcon} onIconChange={onIconChange} />
      }
    >
      <ImageContent images={images} urls={urls} selectedIcon={selectedIcon} />
    </SectionBasic>
  );
};

export default KnowYourCuts;
